import axios from "axios";
import { useGlobalState } from "../context/GlobalStateContext.jsx";
import {
  SERVER_URL,
  getHttpOptions as httpOptions,
  httpOptionsMult,
  httpOptionsWithOutToken,
} from "./config.js";

const sendRequest = async (
  method: string,
  url: string,
  data: any = null,
  options = {},
  globalState: ReturnType<typeof useGlobalState> | any
) => {
  try {
    globalState.setIsLoading(true);
    const response = await axios({
      method,
      url: SERVER_URL ? SERVER_URL + url : url,
      data,
      ...options,
    });
    return await globalState.handleApiResponse(response.data);
  } catch (error) {
    console.warn("Global State: ", error);

    globalState.handleApiError(error);
    throw error;
  } finally {
    globalState.setIsLoading(false);
  }
};

export const useRemoteService = () => {
  const globalState = useGlobalState();

  const sendPostToServer = (url: string, data: any) =>
    sendRequest("post", url, data, httpOptions, globalState);

  const sendPdfPostToServer = (url: string, data: any) =>
    sendRequest(
      "post",
      url,
      data,
      { ...httpOptions, responseType: "blob" },
      globalState
    );

  const sendGetToServer = (url: string) => {
    console.warn(httpOptions);
    return sendRequest("get", url, null, httpOptions, globalState);
  };

  const sendPostToServerMult = (url: string, data: any) =>
    sendRequest("post", url, data, httpOptionsMult, globalState);

  const sendPostToServerWithOutToken = (url: string, data: any) =>
    sendRequest("post", url, data, httpOptionsWithOutToken, globalState);

  const sendPostToServerPdfWithoutToken = (url: string, data: any) =>
    sendRequest(
      "post",
      url,
      data,
      {
        headers: httpOptionsWithOutToken.headers,
        responseType: "blob",
      },
      globalState
    );

  return {
    sendPostToServer,
    sendGetToServer,
    sendPdfPostToServer,
    sendPostToServerWithOutToken,
    sendPostToServerPdfWithoutToken,
    sendPostToServerMult,
  };
};
